import { Component, OnInit } from '@angular/core';
import {
  Inspection,
  ModalService,
  RouterService,
  StateService,
  ToolService,
} from 'projects/shared/src/public-api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lib-inspection-overview',
  templateUrl: './inspection-overview.component.html',
  styleUrls: ['./inspection-overview.component.scss'],
  standalone: false,
})
export class InspectionOverviewComponent implements OnInit {
  constructor(
    public routerService: RouterService,
    public state: StateService,
    public modalService: ModalService,
    public toolService: ToolService
  ) {}

  private allEntries: Inspection[] = [];
  public filteredEntries: Inspection[] = [];
  private searchTerm: string;
  private sub: Subscription;

  ngOnInit() {
    this.sub = this.state.inspections$.subscribe((x) => {
      this.allEntries = x;
      this.filterEntries();
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  public handleSearchInput(event: any) {
    let term = event.target.value as string;
    this.searchTerm = term.trim().toLocaleLowerCase();
    this.filterEntries();
  }

  private filterEntries() {
    if (!this.searchTerm) {
      this.filteredEntries = this.allEntries;
    } else {
      this.filteredEntries = this.allEntries.filter((entry) =>
        entry.machineName.toLowerCase().includes(this.searchTerm)
      );
    }
  }

  public async openDetailModal(id: string) {
    await this.modalService.openInspectionDetailModal(
      id,
      this.state.isBigScreen
    );
  }
}
